import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme as lexusTheme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import {
    lineClampStyle,
    type LineClampStyleType,
} from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Lineclamp";
import IconWrapper from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const Wrapper = styled.div<{ reachOutMobile?: number }>`
    display: block;
    position: fixed;
    bottom: ${({ reachOutMobile }) => (reachOutMobile ? `${reachOutMobile}px` : 0)};
    left: 0;
    right: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 100vw;
    padding-top: ${lexusTheme.space[2]}px;
    background-color: ${lexusTheme.colors.silver};
    border-top: 1px solid ${lexusTheme.colors.platinumLight};
    z-index: ${lexusTheme.zIndex.mobileBasket};

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
    &::before {
        position: absolute;
        top: -49px;
        left: 0;
        width: 100%;
        height: 48px;
        content: "";
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    }
    ${Button.ButtonPrimary} {
        width: 100%;
        min-width: 0;
        font-size: 1.3rem;
        line-height: 2rem;
        @media ${getBreakpoint("up", "sm")} {
            &:nth-child(3) {
                width: auto;
                max-width: 40%;
            }
        }
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${lexusTheme.space[2]}px;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 ${lexusTheme.space[2]}px ${lexusTheme.space[2]}px ${lexusTheme.space[2]}px;
`;

export const PaymentSwitch = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: ${lexusTheme.space[1]}px;
    width: 100%;
    padding: ${lexusTheme.space[3] / 2}px ${lexusTheme.space[2]}px;
    font-family: ${lexusTheme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
    text-align: start;
    color: ${lexusTheme.colors.azure};
    background-color: ${lexusTheme.colors.platinumLight};
    border: 0;
    border-radius: 0;

    ${IconWrapper} {
        display: flex;
        align-items: center;
    }

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;

export const PaymentControls = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));

    button:nth-last-child(1) {
        border-left: 1px solid ${lexusTheme.colors.titanium};
    }

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }

    html[dir="rtl"] & {
        button:nth-last-child(1) {
            border-right: 1px solid ${lexusTheme.colors.titanium};
        }
    }
`;

export const NextButton = styled(Button.ButtonPrimary)`
    display: block;
    position: relative;
    min-width: 0;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 15px;
    margin-right: 0;
    font-family: ${lexusTheme.fonts.bold};
    font-size: 14px;
    text-transform: uppercase;
    color: ${lexusTheme.colors.white};
    white-space: normal;
    background-color: ${lexusTheme.colors.azure};
    border-radius: 4px;
    &::after {
        display: none;
    }
    &:hover,
    &:active {
        background-color: ${lexusTheme.colors.azureHover};
    }
    @media screen {
        padding: 20px 15px 18px;
    }

    @media screen and (max-width: 400px) {
        padding: 18px 10px 19px;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: 15px;
    }
`;

export const Clamp = styled.span<LineClampStyleType>`
    @media screen and (max-width: 400px) {
        ${lineClampStyle};
    }
`;

export const OpenToggle = styled.span`
    display: flex;
    position: absolute;
    top: -11px;
    left: 50%;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 22px;
    margin-left: -${lexusTheme.space[2]}px;
    padding: 1px ${lexusTheme.space[3] / 2}px;
    color: ${lexusTheme.colors.azure};
    background-color: ${lexusTheme.colors.white};
    border: 1px solid ${lexusTheme.colors.azure};
    border-radius: 6px;
    transform: translateX(${({ theme }) => (theme.isRTL ? "50%" : "-50%")});
    z-index: 1070;

    &:hover {
        border-color: ${lexusTheme.colors.azureHover};
    }

    .dxp-icon {
        color: ${lexusTheme.colors.azure};
    }

    html[dir="rtl"] & {
        left: auto;
        right: 50%;
        margin-left: 0;
        margin-right: -${lexusTheme.space[2]}px;
    }
`;
